import { InsuranceType } from './insurance-type.enum';

export enum LeadStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  ACCEPTED = 'ACCEPTED',
  SENT = 'SENT',
  INACTIVE = 'INACTIVE',
  SUSPENDED = 'SUSPENDED',
  CANCELLED = 'CANCELLED',
  VOID = 'VOID',
  CLOSED = 'CLOSED',
  WAITING_PAIEMENT = 'WAITING_PAIEMENT',
  REJECTED = 'REJECTED',
}

export const getLeadStatusLabel = (status: LeadStatus): string => {
  switch (status) {
    case LeadStatus.PENDING:
      return $localize`Demande de proposition`;
    case LeadStatus.ACTIVE:
      return $localize`Proposition à valider`;
    case LeadStatus.ACCEPTED:
      return $localize`Contrat accepté par le client`;
    case LeadStatus.SENT:
      return $localize`Police en attente de validation`;
    case LeadStatus.INACTIVE:
      return $localize`Police suspendue, annulée ou résiliée`;
    case LeadStatus.SUSPENDED:
      return $localize`Police suspendue`;
    case LeadStatus.CANCELLED:
      return $localize`Demande annulée`;
    case LeadStatus.VOID:
      return $localize`Police annulée`;
    case LeadStatus.CLOSED:
      return $localize`Demande traitée`;
    case LeadStatus.WAITING_PAIEMENT:
      return $localize`En attente de paiement`;
    case LeadStatus.REJECTED:
      return $localize`Propositions refusées`;
    default:
      return '';
  }
};

export const getLeadStatusValues = (insuranceType: InsuranceType) => {
  if (
    insuranceType === InsuranceType.CENTRALISATION ||
    insuranceType === InsuranceType.POLICY_UPDATE ||
    insuranceType === InsuranceType.COLLABORATOR_DECLARATION
  ) {
    return [
      LeadStatus.PENDING,
      LeadStatus.ACTIVE,
      LeadStatus.CANCELLED,
      LeadStatus.CLOSED,
    ];
  }
  if (insuranceType === InsuranceType.CANCELLATION) {
    return [
      LeadStatus.PENDING,
      LeadStatus.ACTIVE,
      LeadStatus.ACCEPTED,
      LeadStatus.CANCELLED,
      LeadStatus.CLOSED,
    ];
  }
  return [
    LeadStatus.PENDING,
    LeadStatus.ACTIVE,
    LeadStatus.ACCEPTED,
    LeadStatus.SENT,
    LeadStatus.CANCELLED,
    LeadStatus.CLOSED,
    LeadStatus.WAITING_PAIEMENT,
  ];
};

export const getCentralisationLeadStatusLabel = (
  status: LeadStatus
): string => {
  switch (status) {
    case LeadStatus.PENDING:
      return $localize`Centralisation en attente`;
    case LeadStatus.ACTIVE:
      return $localize`Centralisation en cours`;
    case LeadStatus.CANCELLED:
      return $localize`Demande annulée`;
    case LeadStatus.CLOSED:
      return $localize`Centralisation finie`;
    default:
      return '';
  }
};

export const getCancellationLeadStatusLabel = (status: LeadStatus): string => {
  switch (status) {
    case LeadStatus.PENDING:
      return $localize`Demande de résiliation`;
    case LeadStatus.ACTIVE:
      return $localize`Résiliation en cours`;
    case LeadStatus.ACCEPTED:
      return $localize`Résiliation envoyée`;
    case LeadStatus.CANCELLED:
      return $localize`Demande annulée`;
    case LeadStatus.CLOSED:
      return $localize`Résiliée`;
    default:
      return '';
  }
};

export const getPolicyUpdateLeadStatusLabel = (status: LeadStatus): string => {
  switch (status) {
    case LeadStatus.PENDING:
      return $localize`Demande de modification`;
    case LeadStatus.ACTIVE:
      return $localize`Modification en cours`;
    case LeadStatus.CANCELLED:
      return $localize`Demande annulée`;
    case LeadStatus.CLOSED:
      return $localize`Terminée`;
    default:
      return '';
  }
};

export const getCollaboratorDeclarationLeadStatusLabel = (
  status: LeadStatus
): string => {
  switch (status) {
    case LeadStatus.PENDING:
      return $localize`Annonce en attente`;
    case LeadStatus.ACTIVE:
      return $localize`Annonce en cours`;
    case LeadStatus.CANCELLED:
      return $localize`Demande annulée`;
    case LeadStatus.CLOSED:
      return $localize`Terminée`;
    default:
      return '';
  }
};

export const getLeadStatusClass = (status: LeadStatus): string => {
  switch (status) {
    case LeadStatus.PENDING:
      return 'blue';
    case LeadStatus.ACTIVE:
    case LeadStatus.ACCEPTED:
      return 'warning';
    case LeadStatus.SENT:
      return 'zinc';
    case LeadStatus.WAITING_PAIEMENT:
      return 'sky';
    case LeadStatus.INACTIVE:
    case LeadStatus.SUSPENDED:
    case LeadStatus.CANCELLED:
    case LeadStatus.REJECTED:
    case LeadStatus.VOID:
      return 'danger';
    case LeadStatus.CLOSED:
      return 'success';
    default:
      return '';
  }
};

export const getGlobalLeadStatus = (
  status: LeadStatus,
  insuranceType: InsuranceType
): string => {
  if (insuranceType === InsuranceType.CENTRALISATION)
    return getCentralisationLeadStatusLabel(status);
  if (insuranceType === InsuranceType.CANCELLATION)
    return getCancellationLeadStatusLabel(status);
  if (insuranceType == InsuranceType.POLICY_UPDATE)
    return getPolicyUpdateLeadStatusLabel(status);
  if (insuranceType == InsuranceType.COLLABORATOR_DECLARATION)
    return getCollaboratorDeclarationLeadStatusLabel(status);
  return getLeadStatusLabel(status);
};

export const getLeadStatusChartLabel = (status: LeadStatus): string => {
  switch (status) {
    case LeadStatus.PENDING:
      return $localize`Demande`;
    case LeadStatus.ACTIVE:
      return $localize`En cours`;
    case LeadStatus.ACCEPTED:
      return $localize`Envoyées`;
    case LeadStatus.CANCELLED:
      return $localize`Annulées`;
    case LeadStatus.CLOSED:
      return $localize`Traitées`;
    default:
      return '';
  }
};
